module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='--- No Payment Items ---\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/costcentre/empty_payment_item.html
// module id = 233
// module chunks = 0